import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1200Model } from '../kymw1200.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { ItemInfo } from '../vo/item-info.model';

/**
 * サイクル設定商品情報登録サービス
 * @export RegistCycleItemInfoService
 * @class RegistCycleItemInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RegistCycleItemInfoService extends PlessJsonResponderSub<null> {
  model: KYMW1200Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistCycleItemInfoService
   */
  private getBody(): PlessRequest {
    const upcatalogs: {
      parameter: {
        MediumType: string;
        PCode: string;
        OrderCode: string;
        PricePattern: string;
        CatalogMemo: string;
        CopyCatalogMemoFlg: string;
      };
    }[] = [];
    this.model.updateItemInfosPerCatalog.forEach(_u => {
      this.model.getAllUpdatedCatalogIds(_u).forEach(_i => {
        upcatalogs.push({
          parameter: {
            MediumType: _u.mediumType,
            PCode: _u.pcode,
            OrderCode: _i,
            PricePattern: _u.catalogInfoMap[_i].pricePattern,
            CatalogMemo: _u.catalogInfoMap[_i].catalogMemo,
            CopyCatalogMemoFlg: _u.catalogInfoMap[_i].copyCatalogMemoFlg ? '1' : '0',
          },
        });
      });
    });

    const updObj = {
      CycleItemInfo: {
        combination: this.model.updateItemInfosPerItem.map(_u => ({
          parameter: {
            MediumType: _u.mediumType,
            PCode: _u.pcode,
            TagId: _u.categoryTagId,
            Memo: _u.goodsMemo,
          },
        })),
      },
      CycleOrderInfo: {
        combination: upcatalogs,
      },
    };
    if (updObj.CycleItemInfo.combination.length < 1)
      delete updObj.CycleItemInfo;
    if (updObj.CycleOrderInfo.combination.length < 1)
      delete updObj.CycleOrderInfo;

    return new PlessRequest({ update: updObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof RegistCycleItemInfoService
   */
  execute(model: KYMW1200Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('registCycleItemInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof RegistCycleItemInfoService
   */
  success() {
    if (this.calbak) this.calbak();
  }
}
